import { DroitApplicatifCode } from '../../../shared/models/user'
import { Menu } from '../../../shared/models/menu'

export const logoUrl = 'assets/img/logos/logo-rpc.png'

export const menu: Menu = [
  {
    label: 'Utilisateurs',
    iconUrl: 'assets/img/picto_utilisateur.png',
    link: '/user-management/utilisateurs',
    isAccessibleFor: (droitCodes: DroitApplicatifCode[]): boolean => droitCodes.includes('UTILISATEUR_CONSULT'),
  },
  {
    label: 'Profils applicatifs',
    iconUrl: 'assets/img/picto_profil_appli.png',
    link: '/user-management/profil-applicatif',
    isAccessibleFor: (droitCodes: DroitApplicatifCode[]): boolean => droitCodes.includes('PROFIL_APP_CONSULT'),
  },
  {
    label: 'Droits applicatifs',
    iconUrl: 'assets/img/picto_droit_appli.png',
    link: '/user-management/droit-applicatif',
    isAccessibleFor: (droitCodes: DroitApplicatifCode[]): boolean => droitCodes.includes('DROIT_APP_CONSULT'),
  },
]
